import React from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../assets/logo/logo.png";

export default function Navbar() {
  const location = useLocation();
  const isHome = location.pathname === "/";

  const scrollToSection = (e, id) => {
    if (!isHome) {
      return;
    }

    e.preventDefault();
    const section = document.querySelector(id);
    if (section) section.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <nav style={styles.nav}>
      <Link to="/" style={styles.logoLink}>
        <img src={logo} alt="GoalFit" style={{ height: 100, width: 120 }} />
      </Link>

      <div style={styles.linksContainer}>
        <a
          style={styles.link}
          href={isHome ? "#features" : "/#features"}
          onClick={(e) => scrollToSection(e, "#features")}
          className="glass-btn"
        >
          Fonctionnalités
        </a>

        <a
          style={styles.link}
          href={isHome ? "#screens" : "/#screens"}
          onClick={(e) => scrollToSection(e, "#screens")}
          className="glass-btn"
        >
          Captures
        </a>

        <a
          style={styles.link}
          href={isHome ? "#download" : "/#download"}
          onClick={(e) => scrollToSection(e, "#download")}
          className="glass-btn"
        >
          Télécharger
        </a>

        {/* <Link style={styles.link} to="/privacy">
          Confidentialité
        </Link>

        <Link style={styles.link} to="/terms">
          Conditions
        </Link> */}
      </div>
    </nav>
  );
}

const styles = {
  nav: {
    padding: "1px 40px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    background: "rgba(255,255,255,0.05)",
    backdropFilter: "blur(10px)",
    position: "sticky",
    top: 0,
    zIndex: 10,
    flexWrap: "wrap",
  },
  logoLink: {
    display: "inline-flex",
    alignItems: "center",
  },

  linksContainer: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 20,
  },

  link: {
    marginLeft: 25,
    color: "#fff",
    textDecoration: "none",
    fontWeight: 600,
    cursor: "pointer",
    padding: "6px 14px",
    borderRadius: 10,
  },
};

/* ------------ RESPONSIVE STYLES (injected automatically) ------------ */
const responsiveStyles = document.createElement("style");
responsiveStyles.innerHTML = `
  /* MOBILE STYLES */
  @media (max-width: 768px) {
    nav {
      flex-direction: column !important;
      justify-content: center !important;
      align-items: center !important;
      padding-top: 1px !important;
      padding-bottom: 10px !important;
    }

    nav img {
      height: 110px !important;
      width: 140px !important;
      display: block !important;
      margin: -20px auto -20px auto !important;
    }

nav div {
      width: auto !important;
      display: flex !important;
      flex-direction: row !important;
      justify-content: center !important;
      gap: 12px !important;
      margin-top: 10px !important;
      flex-wrap: wrap !important;
    }

    nav a {
      margin-left: 0 !important;
      font-size: 12.5px !important;
      padding: 4px 10px !important;
      border-radius: 12px !important;
    }

    .glass-btn {
      background: rgba(255,255,255,0.15) !important;
      border: 1px solid rgba(255,255,255,0.3) !important;
      backdrop-filter: blur(10px) !important;
      box-shadow: 0px 2px 12px rgba(255,255,255,0.15) !important;
      transition: all 0.25s ease !important;
    }

    .glass-btn:hover {
      background: rgba(255,255,255,0.25) !important;
      transform: scale(1.04);
    }

    .glass-btn:active {
      transform: scale(0.96);
    }
  }
`;

document.head.appendChild(responsiveStyles);
